export default "/wp-content/themes/onnit/script/cart/dist/o6AuthorityOverrideMobile-37974b1e.png";